import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import { Deposit } from '../../details'
import { RejectDeposit, RejectDepositForm } from './types'
import { transactionRequestStatus } from '../../../const'
import { depositMounted } from '../../edit/model'

export const mounted = createEvent()
export const unmounted = createEvent()

export const setReject = createEvent<RejectDepositForm>()
export const $reject = restore<RejectDepositForm>(setReject, {
  rejectReason: '',
  inputs: '',
})

// submit reject

export const submitReject = createEvent<RejectDeposit>()

export const rejectTransactionRequest = fx<RejectDeposit, Deposit>({
  method: 'PUT',
  url: `/transaction_request/`,
})

sample({
  clock: submitReject,
  fn: ({ requestId, comment, rejectReason }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
        ]),
      },
      body: {
        requestId: requestId,
        status: transactionRequestStatus.rejected(),
        comment: comment,
        rejectReason: rejectReason,
      },
      url: `/transaction_request/${requestId}`,
    }
  },
  target: rejectTransactionRequest,
})

// clear field on success

sample({
  clock: rejectTransactionRequest.done,
  fn: () => ({}),
  target: [depositMounted],
})
